import React from 'react';

export const CloseCircle = (props: React.SVGProps<SVGSVGElement>) => (
	<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.66667 13.3333C10.3486 13.3333 13.3333 10.3486 13.3333 6.66667C13.3333 2.98477 10.3486 0 6.66667 0C2.98477 0 0 2.98477 0 6.66667C0 10.3486 2.98477 13.3333 6.66667 13.3333ZM6.66667 12C9.61218 12 12 9.61218 12 6.66667C12 3.72115 9.61218 1.33333 6.66667 1.33333C3.72115 1.33333 1.33333 3.72115 1.33333 6.66667C1.33333 9.61218 3.72115 12 6.66667 12Z"
			fill="currentColor"
		/>
		<path
			d="M9.16741 8.36727C9.38864 8.5886 9.38864 8.9462 9.16741 9.16754C9.05706 9.27789 8.9122 9.33333 8.76724 9.33333C8.62238 9.33333 8.47752 9.27789 8.36716 9.16754L6.66667 7.4669L4.96617 9.16754C4.85582 9.27789 4.71096 9.33333 4.5661 9.33333C4.42113 9.33333 4.27627 9.27789 4.16592 9.16754C3.94469 8.9462 3.94469 8.5886 4.16592 8.36727L5.86652 6.66673L4.16592 4.96619C3.94469 4.74486 3.94469 4.38726 4.16592 4.16592C4.38725 3.94469 4.74484 3.94469 4.96617 4.16592L6.66667 5.86656L8.36716 4.16592C8.58849 3.94469 8.94608 3.94469 9.16741 4.16592C9.38864 4.38726 9.38864 4.74486 9.16741 4.96619L7.46681 6.66673L9.16741 8.36727Z"
			fill="currentColor"
		/>
	</svg>
);
